import instance from '@apis/instance';

class MyShopApi {
  static toggleMyShop(shopId: string): Promise<never> {
    return instance.put(`/my-shop/${shopId}`);
  }
}

export default MyShopApi;
